import { DocumentInfo, UploadDocumentos } from 'common/genericTypes';
import { typedAction } from 'store/modules/base';

export interface State {
  uploadDocumentos: UploadDocumentos;
}

export interface Field {
  name: keyof UploadDocumentos;
  value: undefined | null | string;
}

export const uploadDocumentosInitialState: UploadDocumentos = {
  documents: [],
  documentsToDelete: [],
};

export const updateDocuments = (documents: DocumentInfo[]) => {
  return typedAction('cdca/uploadDocumentos/UPDATE', documents);
};

export const updateDocumentsToDelete = (documentsToDelete: DocumentInfo[]) => {
  return typedAction('cdca/uploadDocumentos/documentsToDelete/UPDATE', documentsToDelete);
};

export const resetDocuments = () => {
  return typedAction('cdca/uploadDocumentos/RESET');
};

export type UploadDocumentosAction = ReturnType<
  typeof updateDocuments | typeof resetDocuments | typeof updateDocumentsToDelete
>;
